import { IStore } from 'store/configureStore';

export const selectHomeFilter = (state: IStore) => state.modules.home.dashboardFilter;
export const selectUserStats = (state: IStore) => state.modules.home.dashboardStats;
export const selectIsUserStatsLoading = (state: IStore) => state.modules.home.isStatsLoading;
